// extracted by mini-css-extract-plugin
export default {"container":"Admin_container__Cfe5y","body":"Admin_body__s07zp","center":"Admin_center__Q7UCZ","loginForm":"Admin_loginForm__OFawF","livestreamPane":"Admin_livestreamPane__7z8jM"};